import _ from "lodash";

export const parseUrl = (url) => {
  if (!url || _.isEmpty(url)) { return null; }
  const protocol = url.startsWith("http") ? "" : "https://";
  return new URL(`${protocol}${url}`);
}
